import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-100 to-accent-100/30"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-200/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-200/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3"></div>
      </div>

      <div className="section-container relative z-10 w-full py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-5">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              97影视
              <span className="block text-primary-600 mt-1">电视剧全集在线观看平台</span>
            </h1>

            <p className="mt-3 text-lg md:text-xl text-foreground-600 font-heading">
              {heroData.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20Chinese%20and%20Korean%20drama%20visual%20elements%2C%20floating%20film%20strips%20with%20dramatic%20scenes%2C%20warm%20cinematic%20lighting%2C%20golden%20and%20crimson%20color%20palette%2C%20abstract%20geometric%20overlay%2C%20modern%20entertainment%20aesthetic%2C%20layered%20translucent%20shapes%2C%20dynamic%20flowing%20composition&width=1200&height=900&seq=hero-main-visual&orientation=landscape"
                alt="97影视电视剧在线观看平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}